import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout, isAuthorized } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import Update1 from './update1'
import Update2 from './update2'
import Update3 from './update3'
import Update4 from './update4'
import Update5 from './update5'
import Update6 from './update6'

export default class Updates extends React.Component{

  state = {
    whichUpdate: <Update1 />,
  }


  logout() {
    logout()
    this.setState({ loggedOut: true })
  }

  update1 = () => {
    console.log(`inside this.update 1`);
    this.setState({whichUpdate: <Update1 />});

  }

  update2 = () => {
    this.setState({whichUpdate: <Update2 />})
  }

  update3 = () => {
    this.setState({whichUpdate: <Update3 />})
  }

  update4 = () => {
    this.setState({whichUpdate: <Update4 />})
  }

  update5 = () => {
    this.setState({whichUpdate: <Update5/>})
  }

  update6 = () => {
    this.setState({whichUpdate: <Update6/>})
  }






render() {
  //let currentUpdate = this.state.whichUpdate;
    return  (
<div>
        <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>


        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>

      <div className="App-banner">
        <span className="orange-bold"> NEWFORMA CONNECTED </span>  
      </div>


<div className="content2">



      <div className="left-col">
      <h1 className="left-col-heading">Updates</h1>
      <ul className="left-col-ul">
        <li><a className="doc-link" onClick={this.update1}>Hybrid Update 1.0</a></li>
        <li><a className="doc-link" onClick={this.update2}>Enterprise Update 1.0 Beta</a></li>
        {isAuthorized() ? (<li><a className="doc-link" onClick={this.update3}>Newforma ContructEx Update 1.0</a></li>) : ''}
        <li><a className="doc-link" onClick={this.update4}>Local Auth Update</a></li>
        <li><a className="doc-link" onClick={this.update5}>Newforma Enterprise API Released</a></li>
        <li><a className="doc-link" onClick={this.update6}>New! Service to Service Auth</a></li>

      </ul>


      </div>

      <div className="right-col-updates">

        <div>{this.state.whichUpdate}</div>
      </div>

    </div>
  </div>)
}
}



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/index.js
 **/